(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-grid-primo"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.dataset.ycReady)return;
    root.dataset.ycReady='true';
    const dialog=root.querySelector('.yc-panel'),trigger=root.querySelector('.yc-trigger'),form=root.querySelector('.yc-form'),motion=matchMedia('(prefers-reduced-motion: reduce)');
    let previousOverflow='',observer;
    const animations=new Set();
    if(typeof dialog.showModal==='function'){
      trigger.hidden=false;
      trigger.addEventListener('click',()=>{previousOverflow=document.body.style.overflow;dialog.showModal();document.body.style.overflow='hidden';trigger.setAttribute('aria-expanded','true');});
      root.querySelector('.yc-close').addEventListener('click',()=>dialog.close());
      dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});
      dialog.addEventListener('close',()=>{document.body.style.overflow=previousOverflow;trigger.setAttribute('aria-expanded','false');form.reset();trigger.focus({preventScroll:true});});
    }else{dialog.setAttribute('open','');}
    form.addEventListener('submit',event=>{
      const fields=Array.from(form.querySelectorAll('input[type=number]'));
      for(let i=0;i<fields.length;i+=2){const low=fields[i],high=fields[i+1];high.setCustomValidity('');if(low.value!==''&&high.value!==''&&Number(low.value)>Number(high.value)){high.setCustomValidity(form.dataset.rangeError);high.reportValidity();event.preventDefault();return;}}
      fields.forEach(input=>{if(input.value==='')input.disabled=true;});
    });
    form.addEventListener('input',()=>form.querySelectorAll('input[type=number]').forEach(input=>input.setCustomValidity('')));
    if(!motion.matches&&'IntersectionObserver' in window){
      observer=new IntersectionObserver(entries=>{let index=0;entries.forEach(entry=>{if(!entry.isIntersecting)return;observer.unobserve(entry.target);if(motion.matches)return;const anim=entry.target.animate([{opacity:.15,transform:'translateY(14px)'},{opacity:1,transform:'translateY(0)'}],{duration:400,delay:Math.min(index++*45,90),easing:'cubic-bezier(.2,.7,.2,1)',fill:'backwards'});animations.add(anim);anim.onfinish=()=>animations.delete(anim);});},{threshold:0,rootMargin:'0px 0px -24px 0px'});
      root.querySelectorAll('.yc-card').forEach(card=>observer.observe(card));
    }
    motion.addEventListener('change',()=>{if(motion.matches){if(observer)observer.disconnect();animations.forEach(anim=>anim.cancel());animations.clear();}});
    document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(root)){if(dialog.open)dialog.close();if(observer)observer.disconnect();animations.forEach(anim=>anim.cancel());}});
  }
  document.querySelectorAll('.yc').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.yc').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-primo"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const variants = JSON.parse(root.querySelector('[data-variants]').textContent);
    const labels = JSON.parse(root.querySelector('[data-labels]').textContent);
    const form = root.querySelector('.yp-form');
    const select = form.querySelector('select[name="id"]');
    const groups = [...root.querySelectorAll('[data-option-index]')];
    const buttons = [...root.querySelectorAll('[data-add]')];
    const status = root.querySelector('.yp-status');
    const track = root.querySelector('.yp-track');
    const slides = [...root.querySelectorAll('.yp-media')];
    const thumbs = [...root.querySelectorAll('[data-media-target]')];
    let current = variants.find(v => String(v.id) === select.value);
    let busy = false;
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    root.classList.add('yp-enhanced');
    root.querySelector('.yp-option-groups').hidden = false;
    const showMedia = (id, instant = false) => {
      const slide = slides.find(s => s.dataset.media === String(id));
      if (slide) track.scrollTo({left:slide.offsetLeft - slides[0].offsetLeft,behavior:instant || reduced.matches ? 'auto' : 'smooth'});
    };
    const render = () => {
      buttons.forEach(button => {
        button.disabled = busy || !current?.available;
        button.querySelector('[data-add-label]').textContent = busy ? labels.adding : !current ? labels.unavailable : current.available ? labels.add : labels.sold;
      });
      if (current) {
        select.value = String(current.id);
        root.querySelectorAll('[data-price]').forEach(el => {el.textContent=current.price;});
        const compare = root.querySelector('[data-compare]');
        compare.hidden = !current.compare;
        compare.textContent = current.compare || '';
      } else select.value = '';
      const selected = groups.map(g => g.querySelector('input:checked')?.value);
      groups.forEach((group,index) => group.querySelectorAll('input').forEach(input => {
        const available = variants.some(v => v.available && v.options[index] === input.value && selected.slice(0,index).every((value,i) => v.options[i] === value));
        input.closest('label').classList.toggle('yp-unavailable',!available);
      }));
    };
    groups.forEach(group => group.addEventListener('change',() => {
      const selected = groups.map(g => g.querySelector('input:checked')?.value);
      current = variants.find(v => v.options.every((value,index) => value === selected[index]));
      status.textContent = '';
      root.querySelector('.yp-view-bag').hidden = true;
      render();
      if (current) {
        const url = new URL(location.href);
        url.searchParams.set('variant',current.id);
        history.replaceState({},'',url);
        if (current.media) showMedia(current.media);
      }
    }));
    thumbs.forEach(button => button.addEventListener('click',() => showMedia(button.dataset.mediaTarget)));
    root.querySelectorAll('[data-gallery-step]').forEach(button => button.addEventListener('click',() => {
      const index = Math.round(track.scrollLeft / track.clientWidth);
      const next = Math.max(0,Math.min(slides.length-1,index+Number(button.dataset.galleryStep)));
      showMedia(slides[next]?.dataset.media);
    }));
    if (slides.length) {
      const galleryObserver = new IntersectionObserver(entries => entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        const index = slides.indexOf(entry.target);
        const counter = root.querySelector('.yp-counter');
        if (counter) counter.textContent = `${index+1} / ${slides.length}`;
        thumbs.forEach(button => button.setAttribute('aria-pressed',String(button.dataset.mediaTarget === entry.target.dataset.media)));
      }),{root:track,threshold:.6});
      slides.forEach(slide=>galleryObserver.observe(slide));
      requestAnimationFrame(()=>showMedia(labels.initialMedia,true));
    }
    const primary = form.querySelector('[data-add]');
    const sticky = root.querySelector('.yp-sticky');
    const stickyObserver = new IntersectionObserver(entries => {
      sticky.hidden = entries[0].isIntersecting || entries[0].boundingClientRect.bottom > 0;
    },{threshold:0});
    stickyObserver.observe(primary);
    root.querySelector('[data-shipping-link]').addEventListener('click',() => {root.querySelector('.yp-policy-links').closest('details').open=true;});
    form.addEventListener('submit',async event => {
      event.preventDefault();
      if (busy || !current?.available) return;
      busy = true;
      status.textContent = '';
      render();
      try {
        const response = await fetch(labels.cartAdd,{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || labels.error);
        status.textContent = labels.added;
        root.querySelector('.yp-view-bag').hidden = false;
        if (typeof window.updateCartCount === 'function') window.updateCartCount();

      } catch (error) {
        status.textContent = error.message || labels.error;
        status.scrollIntoView({block:'center',behavior:reduced.matches?'auto':'smooth'});
      } finally {busy=false;render();}
    });
    render();
  }
  document.querySelectorAll('.yp-product').forEach(init);
  document.addEventListener('shopify:section:load',event=>{event.target.querySelectorAll('.yp-product').forEach(init);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yaisu-instinct-home"] && !Shopify.designMode) return;
  try {
    
(() => {
 const reduced = matchMedia('(prefers-reduced-motion: reduce)');
 const active = new Set();
 const observers = new Set();
 const initialize = scope => {
  if (reduced.matches || !window.IntersectionObserver || !Element.prototype.animate) return;
  const roots = scope.matches?.('.yi-home') ? [scope] : scope.querySelectorAll('.yi-home');
  roots.forEach(root => {
   if (root.dataset.yiMotion) return;
   root.dataset.yiMotion = 'impact-titles';
   const mobile = matchMedia('(max-width:700px)').matches;
   const run = (element, frames, duration, delay = 0) => {
    const animation = element.animate(frames, {duration, delay, fill:'backwards', easing:'cubic-bezier(.2,.7,.25,1)'});
    active.add(animation);
    animation.finished.then(() => active.delete(animation), () => active.delete(animation));
   };
   const rise = (element, delay = 0) => run(element,[{opacity:0,transform:`translateY(${mobile ? 18 : 26}px)`},{opacity:1,transform:'translateY(0)'}],480,delay);
   const observer = new IntersectionObserver(entries => {
    const visible = entries.filter(entry => entry.isIntersecting);
    visible.forEach((entry,index) => {
     observer.unobserve(entry.target);
     if (reduced.matches || document.hidden) return;
     const element = entry.target;
     const delay = Math.min(index * 55,110);
     if (element.matches('h2')) {
      run(element,[
       {opacity:.2,clipPath:'inset(100% 0 0 0)',transform:`translateY(${mobile ? 24 : 38}px) scale(.97)`},
       {opacity:1,clipPath:'inset(0% 0 0 0)',transform:'translateY(0) scale(1)'}
      ],560);
     } else if (element.matches('.yi-editorial-photo')) {
      const image = element.querySelector('img');
      if(image) run(image,[{opacity:.35,transform:`translateY(${mobile ? 8 : 12}px) scale(1.045)`},{opacity:1,transform:'translateY(0) scale(1)'}],580);
     } else if(element.matches('.yi-editorial-copy')) {
      [...element.children].filter(child => !child.matches('h2')).forEach((child,i) => rise(child,Math.min(i*45,120)));
     } else if(element.matches('.yi-brand')) {
      [...element.children].filter(child => !child.matches('h2')).forEach((child,i) => rise(child,i*45));
     } else {
      rise(element,delay);
     }
    });
   }, {threshold:0,rootMargin:'0px 0px -64px 0px'});
   root.querySelectorAll('.yi-section-head h2,.yi-section-head>a,.yi-product,.yi-editorial-photo,.yi-editorial-copy,.yi-editorial-copy h2,.yi-categories a,.yi-brand,.yi-brand h2').forEach(element => observer.observe(element));
   observers.add(observer);
  });
 };
 initialize(document);
 document.addEventListener('shopify:section:load', event => initialize(event.target));
 reduced.addEventListener('change', () => {
  if(!reduced.matches) return;
  observers.forEach(observer => observer.disconnect());
  active.forEach(animation => animation.cancel());
  active.clear();
 });
})();


  } catch(e) { console.error(e); }
})();
})();
